import React, { FC } from 'react';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import DownloadIcon from '../../../../../assets/icons/download-icon';
import { downloadConfigFile } from '../../../../../store/commands/configuration-files/actions';

const DownloadTableCell: FC<any> = (properties: {
  row: {
    fileTypeId: string;
    hash: string;
    fileName: string | null;
  };
}) => {
  const dispatch = useDispatch();

  const {
    row: { fileTypeId, hash, fileName },
  } = properties;
  const handleClick = async () => {
    await dispatch(
      downloadConfigFile({
        fileName,
        fileTypeId,
        hash,
      }),
    );
  };
  return (
    <IconButton
      id={`download-button-${fileTypeId}`}
      style={{ width: '30px', height: '30px', padding: '0' }}
      onClick={handleClick}
      size="small"
    >
      <DownloadIcon />
    </IconButton>
  );
};

export default DownloadTableCell;
